import LinkType from '~/types/LinkType';

const InlineButton = (link: LinkType) => {
    return `<a href="${link.url}" class="btn btn-${link.style}">${link.label}</a>`;
};

export { InlineButton };
